// 整个应用的共享数据
import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user.js'
import permission from './modules/permission.js'
import getters from './getters.js'
import tagsView from './modules/tagsView.js'
Vue.use(Vuex)

// export default new Vuex.Store({
//     // state,
//     getters,
//     // mutations,
//     // actions,
//     // modules
// })

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    tagsView,
    user
  },
  getters
})

export default store
